import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiShield,FiMail,FiPhone}=FiIcons;

const Header=()=> {
  return (
    <motion.header
      initial={{y: -100,opacity: 0}}
      animate={{y: 0,opacity: 1}}
      transition={{duration: 0.8,ease: "easeOut"}}
      className="relative z-20 bg-slate-950/50 backdrop-blur-md border-b border-blue-500/20"
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <motion.div
            className="flex items-center space-x-3"
            whileHover={{scale: 1.05}}
            transition={{type: "spring",stiffness: 300}}
          >
            <div className="relative">
              <motion.div
                className="absolute inset-0 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full blur-sm"
                animate={{rotate: 360}}
                transition={{duration: 8,repeat: Infinity,ease: "linear"}}
              />
              <div className="relative bg-gradient-to-r from-blue-600 to-indigo-700 p-3 rounded-full">
                <SafeIcon icon={FiShield} className="w-8 h-8 text-white" />
              </div>
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">
                MX2.Heinsberg.org
              </h1>
              <p className="text-gray-400 text-xs tracking-wider uppercase">Powered by Visio Wasacon GmbH</p>
            </div>
          </motion.div>

          <div className="hidden md:flex items-center space-x-6 text-gray-300">
            <motion.div
              className="flex items-center space-x-2"
              whileHover={{scale: 1.1,color: "#60a5fa"}}
            >
              <SafeIcon icon={FiMail} className="w-4 h-4" />
              <span className="text-sm">abuse@wasacon.net</span>
            </motion.div>
            <motion.div
              className="flex items-center space-x-2"
              whileHover={{scale: 1.1,color: "#60a5fa"}}
            >
              <SafeIcon icon={FiPhone} className="w-4 h-4" />
              <span className="text-sm">+49 2452 8608373</span>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;